import React, { FC } from 'react';
import Typography from '@mui/material/Typography';
import styled, { css } from 'styled-components';

const Circle = styled.div<{ circleColor?: string }>`
  background: ${props => props.circleColor};
  border-radius: 50px;
  height: 20px;
  margin-right: 8px;
  min-height: 20px;
  min-width: 20px;
  width: 20px;
  -moz-border-radius: 50px;
  -webkit-border-radius: 50px;
`;

const ItemContainer = styled.div<{ marginLeft: string, onClick: any, isDisabled: boolean }>`
  cursor: default;
  display: flex;
  justify-content: flex-start;
  padding: 5px;
  padding-left: ${props => props.marginLeft || '105px'};
  width: 220px;
  ${(props: { onClick: any, isDisabled: boolean }) =>
  (props.onClick !== undefined && !props.isDisabled) &&
    css`
      &:hover {
        border-radius: 10px;
        background-color: #f4f4f4; //fallback for IE
        background-color: rgb(211, 211, 211, 0.25);
        cursor: pointer;
      }
    `}
`;

const StyledTypography = styled(Typography)`
  color: #555555;
  font-size: 14px;
  padding-top: 2px;
`;

export interface ILegendProps {
  'data-testid'?: string;
  colors: string[];
  data: Array<IDataProps>;
  marginLeft?: string;
}

export interface IDataProps {
  isDisabled?: boolean;
  name: string;
  onClick?: () => void;
  value?: number;
}

export const Legend: FC<ILegendProps> = props => {
  return (
    <div data-testid={props["data-testid"]}>
      {props.data.map((entry, index) => (
        <ItemContainer
          isDisabled={entry.isDisabled ? entry.isDisabled : false}
          key={`legend-item-${index}`}
          marginLeft = {props.marginLeft || '105px'}
          onClick = {entry.isDisabled ? undefined : entry.onClick}>
          <Circle circleColor={props.colors[index % props.colors.length]} key={`circle-${index}`} />
          <StyledTypography key={`name-${index}`}>{entry.value}  {entry.name}</StyledTypography>
        </ItemContainer>
      ))}
    </div>
  );
};
